import { useParams } from "react-router";
import { invariant } from "src/common/utils/invariant.js";

/** Data sources is mounted at both scopes — links inside it must keep the current one. */
export const useDataSourcesBasePath = () => {
	const { companyDomainId, legalEntityId } = useParams();
	invariant(
		companyDomainId,
		"useDataSourcesBasePath: missing companyDomainId param",
	);
	return legalEntityId
		? `/company-domains/${companyDomainId}/legal-entities/${legalEntityId}/data-sources`
		: `/company-domains/${companyDomainId}/data-sources`;
};
